import React, { Component } from 'react';
import Banner from "../../assets/ourides/banner-boats.jpg";
import CaptainIMG from "../../assets/badges/captain.png";

export default class Captain extends Component {

    render() {
        return (
            <div className="captain__main">
                <div className="captain__container">
                    <img src={Banner} className="captain__bg" />
                    <div className="captain__wrapper">
                        <img src={CaptainIMG} className="captain__icon"/>
                        <h4 className="captain__title rides-title"> Le Forfait Capitaine </h4>
                        <p className="center">
                            <span className="rides-tagline captain__tagline"> PAS DE LICENCE? PAS DE PROBLÈME! </span>
                            <span className="captain__text"> Notre Forfait Capitaine permet à quiconque d'accéder à une balade. Un propriétaire qualifié fera profiter d’une promenade à ceux et celles qui ne possèdent aucun permis pour assurer la sécurité de tous les passagers. </span>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}